module.exports = __webpack_public_path__ + "img/backgroundSnow.bd532519.png";